export enum AmqSubscriptionTypeEnum {
  equipmentSubscription
}